
















site = require '@/../config/site'

import GeotapLogo from '@/components/GeotapLogo'
import StoreLinks from '@/components/StoreLinks'

export default {
  name: 'lucre-footer',

  components: 
    'geotap-logo': GeotapLogo 
    'store-links': StoreLinks
    
  data: -> 
    socialLinks: site.social.links
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Footer.vue